<template>
  <UButton v-bind="$attrs" block size="xl" class="mb-2 lg:mb-4" variant="outline">
    <slot />
  </UButton>
</template>
